export class Permission {
  id: string;
  name: string;
}


